/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import _ from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  cycleContainer: {
    border: "1px solid #777777",
    borderRadius: 18,
    marginRight: "13px",
  },
  activeCycleContainer: {
    border: "1px solid #777777",
    borderRadius: 18,
    marginRight: "13px",
    backgroundColor: "#777777",
  },
  textCycle: {
    padding: "4px 8px 4px 8px",
    color: "#777777",
    "&:hover": {
      cursor: "pointer",
    },
  },
  activeTextCycle: {
    padding: "4px 8px 4px 8px",
    color: "white",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function SelectorCycleTradePromotionAnnualComponent({
  setTitleCycleActive,
  setCurrentMonth,
  listCycles,
  isDataReady,
}) {
  const classes = useStyles();
  const scenariosSlice = useSelector((state) => state.scenarios);
  const initialHoverActiveCycle = {};
  _.forEach(listCycles, (cycle, index) => {
    if (index === 0) {
      initialHoverActiveCycle[cycle] = true;
    } else {
      initialHoverActiveCycle[cycle] = false;
    }
  });

  const [isActiveCycle, setIsActiveCycle] = useState(initialHoverActiveCycle);

  const handleActiveCycle = (month) => {
    if (isDataReady) {
      if (month === "AllMonths") {
        setTitleCycleActive(
          `From ${moment(
            scenariosSlice.selectedScenario.scenario.cycle.initial_date
          ).format("MMM'YY")} to ${moment(
            scenariosSlice.selectedScenario.scenario.cycle.final_date
          ).format("MMM'YY")}`
        );
        setCurrentMonth("AllMonths");
      } else {
        setTitleCycleActive(month);
        const monthFormmated = moment(month, "MMM'YYYY").set("date", 15);
        setCurrentMonth(monthFormmated.format("YYYY-MM-DD").toString());
      }

      setIsActiveCycle({
        ...initialHoverActiveCycle,
        AllMonths: false,
        [month]: true,
      });
    }
  };

  return (
    <>
      {listCycles.map((month) => (
        <Box
          className={
            isActiveCycle[month]
              ? classes.activeCycleContainer
              : classes.cycleContainer
          }
          onClick={() => handleActiveCycle(month)}
        >
          <Typography
            variant="body1"
            className={
              isActiveCycle[month] ? classes.activeTextCycle : classes.textCycle
            }
          >
            {month === "AllMonths" ? "All Months" : month}
          </Typography>
        </Box>
      ))}
    </>
  );
}
export default SelectorCycleTradePromotionAnnualComponent;
